import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "@angular/common";
import * as i3 from "@angular/forms";
function NotificationPreferencesComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 2)(1, "input", 3);
    i0.ɵɵtwoWayListener("ngModelChange", function NotificationPreferencesComponent_label_1_Template_input_ngModelChange_1_listener($event) { const preference_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r2.state[preference_r2].active, $event) || (ctx_r2.state[preference_r2].active = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("click", function NotificationPreferencesComponent_label_1_Template_input_click_1_listener() { const preference_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateActiveState(ctx_r2.state[preference_r2].active, ctx_r2.state[preference_r2].preferenceName)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 4);
    i0.ɵɵelementStart(3, "span", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const preference_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.state[preference_r2].active);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.state[preference_r2].label);
} }
export class NotificationPreferencesComponent {
    constructor(accountsService) {
        this.accountsService = accountsService;
        // TODO: add the saved_item_removed_from_report_emails preference here after
        // we release saved asset pdf report modules to all users
        this.preferenceKeys = [
            'share_notification_emails',
            'model_portfolio_state_emails',
            'model_portfolio_bulk_upload_emails',
            'custom_security_bulk_upload_emails',
            'added_to_share_group_emails',
        ];
        this.state = {
            share_notification_emails: {
                active: true,
                label: 'When something is shared with me',
                preferenceName: 'share_notification_emails',
            },
            model_portfolio_state_emails: {
                active: true,
                label: 'When a Model Portfolio needs review',
                preferenceName: 'model_portfolio_state_emails',
            },
            model_portfolio_bulk_upload_emails: {
                active: true,
                label: 'When a bulk Model Portfolio upload needs review',
                preferenceName: 'model_portfolio_bulk_upload_emails',
            },
            custom_security_bulk_upload_emails: {
                active: true,
                label: 'When a bulk Custom Security upload needs review',
                preferenceName: 'custom_security_bulk_upload_emails',
            },
            added_to_share_group_emails: {
                active: true,
                label: 'When someone adds me to a Share Group',
                preferenceName: 'added_to_share_group_emails',
            },
        };
    }
    ngOnInit() {
        this.accountsService.getUserPreferences().subscribe((preference) => {
            this.state.model_portfolio_bulk_upload_emails.active = preference.model_portfolio_bulk_upload_emails;
            this.state.custom_security_bulk_upload_emails.active = preference.custom_security_bulk_upload_emails;
            this.state.model_portfolio_state_emails.active = preference.model_portfolio_state_emails;
            this.state.share_notification_emails.active = preference.share_notification_emails;
            this.state.added_to_share_group_emails.active = preference.added_to_share_group_emails;
        });
    }
    updateActiveState(active, preferenceName) {
        const newPreference = !this.state[preferenceName].active;
        this.state[preferenceName].active = newPreference;
        const newPreferenceRequest = {};
        newPreferenceRequest[preferenceName] = newPreference;
        this.accountsService.putUserPreferences(newPreferenceRequest).subscribe({
            next: () => { },
            error: () => {
                this.state[preferenceName].active = !newPreference;
            },
        });
    }
}
NotificationPreferencesComponent.ɵfac = function NotificationPreferencesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationPreferencesComponent)(i0.ɵɵdirectiveInject(i1.AccountsService)); };
NotificationPreferencesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationPreferencesComponent, selectors: [["ycn-notification-preferences"]], standalone: false, decls: 2, vars: 1, consts: [[1, "custom-controls-stacked"], ["class", "custom-control custom-checkbox", 4, "ngFor", "ngForOf"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "click", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function NotificationPreferencesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, NotificationPreferencesComponent_label_1_Template, 5, 2, "label", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.preferenceKeys);
    } }, dependencies: [i2.NgForOf, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgModel], encapsulation: 2 });
